import { filterDFMFeedback } from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/logic'

import { DFM_FAILURE } from './partsConstants'

export function isDfmFailure(dfmFeedback) {
    const failureDFMFeedback = filterDFMFeedback(dfmFeedback, DFM_FAILURE)

    return failureDFMFeedback && failureDFMFeedback.length > 0
}
